import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const LyngPage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  return (
    <Layout location={props.location}>
      <Helmet>
        <html className="memberpage" lang="da" />
      </Helmet>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <div className="space-8"></div>

            <div className="grid">
              <div className="member-2col-left">
                <div className="member-inner">
                  <h1>Lyng Salling</h1>
                  <h3>Professional</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Date of employment at Emento
                      </div>
                      <div class="flex-row" role="cell">
                        May 2015
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Title
                      </div>
                      <div class="flex-row" role="cell">
                        DPO and TRUST General Secretary
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Responsibilities
                      </div>
                      <div class="flex-row" role="cell">
                        GDPR, IT Security, cross company projects
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Educational background
                      </div>
                      <div class="flex-row" role="cell">
                        Master of Science in Innovation Management and Business
                        Development
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Previous positions/industries
                      </div>
                      <div class="flex-row" role="cell">
                        Project assistant/Healthcare
                      </div>
                    </div>
                  </div>
                  <h3>Personal</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Bucket list no. 1
                      </div>
                      <div class="flex-row" role="cell">
                        Incha Trail
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Favorite music
                      </div>
                      <div class="flex-row" role="cell">
                        Nick cave and the Bad Seeds
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Biggest food or drink consumption
                      </div>
                      <div class="flex-row" role="cell">
                        Chocolate
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Best TV series
                      </div>
                      <div class="flex-row" role="cell">
                        The Knick
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Extraordinary skill
                      </div>
                      <div class="flex-row" role="cell">
                        Colour coordination
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Preferred traveling style
                      </div>
                      <div class="flex-row" role="cell">
                        Meeting locals
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        My friends recognizes me for
                      </div>
                      <div class="flex-row" role="cell">
                        Very strong will
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        As a kid, I wanted to become
                      </div>
                      <div class="flex-row" role="cell">
                        Florist
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Social links
                      </div>
                      <div class="flex-row" role="cell">
                        <Link
                          to="https://www.instagram.com/livet_paa_krogen/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Instagram
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-middle">
                <div className="member-hero-inner">
                  <div className="member-hero-box">
                    <div className="member-hero-image">
                      <img
                        src="/images/portraits/internal/lyng_hero.jpg"
                        alt=""
                      />
                    </div>
                    <h3>Feels like: Hermione Granger</h3>
                    Strength
                    <div className="full-bar">
                      <div className="bar size-50" />
                    </div>
                    Artistic
                    <div className="full-bar">
                      <div className="bar size-60" />
                    </div>
                    Spontaneous
                    <div className="full-bar">
                      <div className="bar size-30" />
                    </div>
                    Determined
                    <div className="full-bar">
                      <div className="bar size-100" />
                    </div>
                    Polite
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Playful
                    <div className="full-bar">
                      <div className="bar size-30" />
                    </div>
                    Empathy
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Intelligence
                    <div className="full-bar">
                      <div className="bar size-100" />
                    </div>
                    Brave
                    <div className="full-bar">
                      <div className="bar size-60" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-right">
                <div className="member-childhood-inner">
                  <div
                    className="member-childhood-image"
                    style={{
                      backgroundImage: `url(/images/portraits/internal/lyng_child.jpg)`,
                    }}
                  >
                    <div className="blur-bg">
                      <img
                        src="/images/portraits/internal/lyng_child.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default LyngPage
